import { z } from "zod";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { getCorrugates } from "@/api/corrugates-api";
import { type Corrugate, corrugateSchema } from "@/schemas";

const REFETCH_INTERVAL = 15 * 1000;

type UseCorrugatesQueryOptions = Omit<
	UseQueryOptions<Corrugate[], Error, Corrugate[], string[]>,
	"queryKey" | "queryFn"
>;

const corrugatesSchema = z.array(corrugateSchema);

const fetchCorrugates = async (): Promise<Corrugate[]> => {
	const data = await getCorrugates();

	return corrugatesSchema.enrich({ callSite: "fetchCorrugates" }).parseWithTelemetry(data);
};

export const useCorrugates = (queryConfig: UseCorrugatesQueryOptions = {}) => {
	const query = useQuery({
		queryKey: ["corrugates"],
		queryFn: fetchCorrugates,
		refetchInterval: REFETCH_INTERVAL,
		staleTime: 10 * 1000,
		...queryConfig,
	});

	return {
		corrugates: query.data,
		isLoading: query.isLoading,
		error: query.error,
		refresh: query.refetch,
	};
};
